import NiceModal from "@ebay/nice-modal-react";
import React from "react";
import {Colors, IconAlert} from "@bounce/shared/ui";
import {NoticeDialog} from "@bounce/shared/consumer/bounce-ui";
import {BounceAddressDetails} from "@bounce/shared/consumer/constants";
import {FormValidations} from "@bounce/shared/consumer/helpers";
import {useWebchat} from "~/components/webchat/useWebchat";
import {useAmplitude} from "~/contexts";
import {Pages} from "~/bi-events/enum";

const RescheduleLimitDialog = NiceModal.create(() => {
  const {openChat} = useWebchat();
  const {pageClickEvent} = useAmplitude();

  const phoneNumber = BounceAddressDetails.phone_numbers[0];
  const formattedPhoneNumber = FormValidations.convertInternationalIntoUSFormat(phoneNumber);

  const handleCallUs = () => {
    pageClickEvent({page: Pages.RESCHEDULE_PLAN, cta: "call_us"});
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleOpenChat = () => {
    pageClickEvent({page: Pages.RESCHEDULE_PLAN, cta: "open_chat"});
    openChat({});
  };

  return (
    <NoticeDialog
      title="Your plan was rescheduled within the last 6 months"
      text={`Call us at ${formattedPhoneNumber} during business hours, or start a chat anytime.`}
      image={<IconAlert height={52} width={52} color={Colors.red._800} />}
      buttonText="Call us"
      onClick={handleCallUs}
      secondaryButtonText="Open chat"
      onClickSecondary={handleOpenChat}
    />
  );
});

export default RescheduleLimitDialog;
